import { IGremium } from "../IGremium";
import { IPlangebiet } from "../IPlangebiet";
import { IVerwaltungsbereich } from "../IVerwaltungsbereich";
import { IWirtschaftsplan } from "../IWirtschaftsplan";
import { IWirtschaftsplanErstellung } from "../IWirtschaftsplanErstellung";
import { WirtschaftsplanErstellung } from "../WirtschaftsplanErstellung";

    export interface IWirtschaftsplanViewmodel {
        wirtschaftsplaene: IWirtschaftsplan[];
        wirtschaftsplaenejahre: IWirtschaftsplan[];
        plangebiete: IPlangebiet[];
        verwaltungsbereiche: IVerwaltungsbereich[];
        gremien: IGremium[];
        wirtschaftsplanerstellung: IWirtschaftsplanErstellung;
    }

    export class WirtschaftsplanViewmodel implements IWirtschaftsplanViewmodel {

        static default = {
            wirtschaftsplaene: [],
            wirtschaftsplaenejahre: [],
            plangebiete: [],
            verwaltungsbereiche: [],
            gremien: [],
            wirtschaftsplanerstellung: WirtschaftsplanErstellung.default
        }

        wirtschaftsplaene: IWirtschaftsplan[] = [];
        wirtschaftsplaenejahre: IWirtschaftsplan[] = [];
        plangebiete: IPlangebiet[] = [];
        verwaltungsbereiche: IVerwaltungsbereich[] = [];
        gremien: IGremium[] = [];
        wirtschaftsplanerstellung: IWirtschaftsplanErstellung = {} as WirtschaftsplanErstellung;
    }

